<template>
  <nav-bar title="检测任务分配" />
  <Picker
    label="待分配批次"
    :defaultVal="defaultVal"
    :columns="batchNos"
    @confirm-values="onBatchSelect"
  />
  <Content :bottom="76" :top="100">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getCylinderList"
    />
    <van-checkbox-group v-model="checked">
      <table class="table">
        <tr>
          <td>瓶号</td>
          <td>介质</td>
          <td>送检时间</td>
          <td width="30"></td>
        </tr>
        <tr v-for="item in list" :key="item.gsCode">
          <td>{{ item.gsCode }}</td>
          <td>{{ item.gsMeduimStr }}</td>
          <td>{{ item.sendDate.split(' ')[0] }}</td>
          <td>
            <van-checkbox shape="square" :name="item.cid" />
          </td>
        </tr>
      </table>
    </van-checkbox-group>
  </Content>
  <div class="btn-conatiner van-hairline--top">
    <van-button
      block
      type="primary"
      native-type="button"
      :disabled="!checked.length"
      @click="handleSubmitClick"
    >
      分配
    </van-button>
  </div>
  <!-- 分配 -->
  <van-overlay :show="show" @click="show = false" z-index="10">
    <div class="wrapper" v-if="show">
      <div class="block" @click.stop>
        <van-form @submit="onConfirm">
          <Picker
            label="检测人员 "
            :columns="empList"
            :border="false"
            :require="true"
            @confirm-values="(value) => (empId2 = value.id)"
          />
          <div style="margin: 16px">
            <van-button round block type="primary" native-type="submit">
              确认
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
  </van-overlay>
</template>

<script setup>
import { Toast } from 'vant'
import { ref, computed } from 'vue'
import {
  getBatchList,
  getCylinderListByBatchNo,
  getEmpList,
  allocCylinderList
} from '@/api/cylinderManageUserHome'
import { useStore } from 'vuex'

const store = useStore()
const companyId = computed(() => store.state.roleInfo.companyId)
const empId = computed(() => store.state.roleInfo.empId)
const checked = ref([])
const defaultVal = ref('')

// 获取批次
const batchNos = ref([])
const getBatchNo = async () => {
  const { data } = await getBatchList({ companyId: companyId.value })
  batchNos.value = data.map((item) => ({
    dicValMean: item
  }))
  console.log(data)
}
getBatchNo()

// 获取钢瓶列表
const batchNo = ref('')
const showLoading = ref(false)
const isLoading = ref(false)
const list = ref([])
const getCylinderList = async () => {
  showLoading.value = true
  isLoading.value = true
  try {
    const { data } = await getCylinderListByBatchNo({
      batchNo: batchNo.value,
      companyId: companyId.value
    })
    list.value = data
    showLoading.value = false
    isLoading.value = false
  } catch {
    isLoading.value = false
  }
}
getCylinderList()

// 选择批次
const onBatchSelect = (val) => {
  batchNo.value = val.dicValMean
  getCylinderList()
}
// 获取检测人员
const empList = ref([])
const getEmpListFn = async () => {
  const { data } = await getEmpList({
    status: '1',
    companyId: companyId.value
  })
  console.log(data, 88)
  empList.value = data.map((item) => {
    return {
      ...item,
      dicValMean: item.name
    }
  })
}
getEmpListFn()
const show = ref(false)
const empId2 = ref('')
const handleSubmitClick = () => {
  if (checked.value.length) {
    show.value = true
  } else {
    Toast('请选择钢瓶')
  }
}
const onConfirm = async (value) => {
  Toast.loading({
    duration: 0,
    forbidClick: true,
    message: '请稍后...'
  })
  try {
    await allocCylinderList({
      allocEmpNo: empId2.value,
      codeArr: checked.value.join(','),
      empId: empId.value
    })
    Toast.clear()
    show.value = false
    Toast.success('操作成功')
    defaultVal.value = '请选择'
    batchNo.value = ''
    list.value = []
    // defaultVal.value = ''
    getBatchNo()
  } catch {
    Toast.clear()
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  padding: 20px;
  background-color: #fff;
}
.btn-conatiner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
}
.table {
  font-size: 12px;
  width: 100%;
}
.table td {
  padding: 10px;
}
</style>
